
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AgreementShowEditBillingInfo from '@/components/agreements/agreement-management/show-edit-billing-info.vue'
import { AgreementsRouteNames } from '@/router/routes-names'
import { useAgreementModule } from '@/modules/agreements'

export default defineComponent({
    name: 'view-agreements-show-billing-info',
    components: {
        AgreementShowEditBillingInfo
    },
    async setup () {
        const route = useRoute()
        const router = useRouter()
        const { getAgreementBillingInfo, agreementBillingInfo } = useAgreementModule()

        const agreementId = route.params.agreementId as string
        await getAgreementBillingInfo(agreementId)

        function onGoToInfo () {
            router.push({ name: AgreementsRouteNames.SHOW, params: { agreementId: agreementId }, query: { ...route.query } })
        }

        return {
            agreementBillingInfo,
            agreementId,
            AgreementsRouteNames,
            onGoToInfo
        }
    }
})
